<template>
<body class="videoBody">
    <header class="width_total_100 headerBg animateContent videoAnimate1">
        <div class="w_container">
            <div class="commonTop">
                <OmpLink></OmpLink>
            </div>
            <div class="bannerPart">
                <div>
                    <div>大数据时代的数据分析处理神器</div>
                    <p>为您的工作效率加分</p>
                </div>
                <FreeTryButton @getFreeTryVisible="getVisible"></FreeTryButton>
            </div>
        </div>
    </header>
    <div class="width_total_100 proBottomBg" style="margin-top:-710px;">
        <div class="w_container">
            <div class="search">
                <input type="text" id="searchText" v-model="searchText"/>
                <el-button type="primary" @click="search">搜索</el-button>
            </div>
            <el-tabs v-model="activeName" @tab-click="handleClick" style="background:#fff;box-shadow: 0 8px 24px 0 rgb(63 74 105 / 16%);">
                <el-tab-pane :label="videoJson.newest.name" name="first"><!--最新上架-->
                    <div class="dataAccess">
                        <div class="clear videoBox" style="margin:0;">
                            <template v-for="item in videoJson.newest.videoList">
                                <div class="perVideo positionR height140" :key="'newest'+item.id" style="margin-bottom: 60px;">
                                    <img :src="'https://escloud.digiwincloud.com/static/zh-CN/img/'+ item.id +'.png'" alt="" class="imgWidth">
                                    <p class="des positionA">&nbsp;&nbsp;&nbsp;{{item.title}}
                                        <a @click="toPlaying(item.id, item.title)" class="kailong floatright"></a>
                                    </p>
                                </div>
                            </template>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane :label="videoJson.popular.name" name="second"><!--热门视频-->
                    <div class="dataAccess">
                        <div class="clear videoBox" style="margin:0;">
                            <template v-for="item in videoJson.popular.videoList">
                                <div class="perVideo positionR height140" :key="'popular'+item.id" style="margin-bottom: 60px;">
                                    <img :src="'https://escloud.digiwincloud.com/static/zh-CN/img/'+ item.id +'.png'" alt="" class="imgWidth">
                                    <p class="des positionA">&nbsp;&nbsp;&nbsp;{{item.title}}
                                        <a @click="toPlaying(item.id, item.title)" class="kailong floatright"></a>
                                    </p>
                                </div>
                            </template>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane :label="videoJson.datasource.name" name="third"><!--数据接入-->
                    <div class="dataAccess">
                        <div class="clear videoBox" style="margin:0;">
                            <template v-for="item in videoJson.datasource.videoList">
                                <div class="perVideo positionR height140" :key="'datasource'+item.id" style="margin-bottom: 60px;">
                                    <img :src="'https://escloud.digiwincloud.com/static/zh-CN/img/'+ item.id +'.png'" alt="" class="imgWidth">
                                    <p class="des positionA">&nbsp;&nbsp;&nbsp;{{item.title}}
                                        <a @click="toPlaying(item.id, item.title)" class="kailong floatright"></a>
                                    </p>
                                </div>
                            </template>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane :label="videoJson.worksheet.name" name="fourth"><!--数据处理-->
                    <div class="dataAccess">
                        <div class="clear videoBox" style="margin:0;">
                            <template v-for="item in videoJson.worksheet.videoList">
                                <div class="perVideo positionR height140" :key="'worksheet'+item.id" style="margin-bottom: 60px;">
                                    <img :src="'https://escloud.digiwincloud.com/static/zh-CN/img/'+ item.id +'.png'" alt="" class="imgWidth">
                                    <p class="des positionA">&nbsp;&nbsp;&nbsp;{{item.title}}
                                        <a @click="toPlaying(item.id, item.title)" class="kailong floatright"></a>
                                    </p>
                                </div>
                            </template>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane :label="videoJson.chartDesign.name" name="fifth"><!--图表设计-->
                    <div class="dataAccess">
                        <div class="clear videoBox" style="margin:0;">
                            <template v-for="item in videoJson.chartDesign.videoList">
                                <div class="perVideo positionR height140" :key="'chartDesign'+item.id" style="margin-bottom: 60px;">
                                    <img :src="'https://escloud.digiwincloud.com/static/zh-CN/img/'+ item.id +'.png'" alt="" class="imgWidth">
                                    <p class="des positionA">&nbsp;&nbsp;&nbsp;{{item.title}}
                                        <a @click="toPlaying(item.id, item.title)" class="kailong floatright"></a>
                                    </p>
                                </div>
                            </template>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane :label="videoJson.chartType.name" name="sixth"><!--图表类型-->
                    <div class="dataAccess">
                        <div class="clear videoBox" style="margin:0;">
                            <template v-for="item in videoJson.chartType.videoList">
                                <div class="perVideo positionR height140" :key="'chartType'+item.id" style="margin-bottom: 60px;">
                                    <img :src="'https://escloud.digiwincloud.com/static/zh-CN/img/'+ item.id +'.png'" alt="" class="imgWidth">
                                    <p class="des positionA">&nbsp;&nbsp;&nbsp;{{item.title}}
                                        <a @click="toPlaying(item.id, item.title)" class="kailong floatright"></a>
                                    </p>
                                </div>
                            </template>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane :label="videoJson.dashboard.name" name="seventh"><!--可视化分析-->
                    <div class="dataAccess">
                        <div class="clear videoBox" style="margin:0;">
                            <template v-for="item in videoJson.dashboard.videoList">
                                <div class="perVideo positionR height140" :key="'dashboard'+item.id" style="margin-bottom: 60px;">
                                    <img :src="'https://escloud.digiwincloud.com/static/zh-CN/img/'+ item.id +'.png'" alt="" class="imgWidth">
                                    <p class="des positionA">&nbsp;&nbsp;&nbsp;{{item.title}}
                                        <a @click="toPlaying(item.id, item.title)" class="kailong floatright"></a>
                                    </p>
                                </div>
                            </template>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane :label="videoJson.mobile.name" name="eighth"><!--移动应用-->
                    <div class="dataAccess">
                        <div class="clear videoBox" style="margin:0;">
                            <template v-for="item in videoJson.mobile.videoList">
                                <div class="perVideo positionR height140" :key="'mobile'+item.id" style="margin-bottom: 60px;">
                                    <img :src="'https://escloud.digiwincloud.com/static/zh-CN/img/'+ item.id +'.png'" alt="" class="imgWidth">
                                    <p class="des positionA">&nbsp;&nbsp;&nbsp;{{item.title}}
                                        <a @click="toPlaying(item.id, item.title)" class="kailong floatright"></a>
                                    </p>
                                </div>
                            </template>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane :label="videoJson.search.name" name="ninth"><!--搜索结果-->
                    <div class="dataAccess">
                        <div class="clear videoBox" style="margin:0;">
                            <template v-for="item in videoJson.search.videoList">
                                <div class="perVideo positionR height140" :key="'search'+item.id" style="margin-bottom: 60px;">
                                    <img :src="'https://escloud.digiwincloud.com/static/zh-CN/img/'+ item.id +'.png'" alt="" class="imgWidth">
                                    <p class="des positionA">&nbsp;&nbsp;&nbsp;{{item.title}}
                                        <a @click="toPlaying(item.id, item.title)" class="kailong floatright"></a>
                                    </p>
                                </div>
                            </template>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>

			<Footer></Footer>

        </div>
    </div>
    
    <FreeTry :visible.sync="freeTryVisible"></FreeTry>
    <Control></Control>
    <!-- 模态框（Modal） -->
    <div class="modal fade" :id="'myModal'" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="height:64%;">
        <div style="width:70%; margin:0 auto;height:100%">
            <div class="modal-dialog">
                <div class="modal-content" :class="'hh'+popVideoId" style="height:100%">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">×</button>
                        <h4 class="modal-title" id="myModalLabel" style="font-weight:bold">{{popVideoTitle}}</h4>
                    </div>
                    
                    <video :src="'https://escloud.digiwincloud.com/static/zh-CN/video/'+ popVideoId +'.mp4'" controls="controls" preload="auto" :poster="'https://escloud.digiwincloud.com/static/zh-CN/img/'+ popVideoId +'.png'" id="popVideo" autoplay="autoplay" width="100%"></video>
                </div>
            </div>
        </div>
    </div>

</body>
</template>
<script>
// import { Button, Modal } from 'iview' 1111111111111111111111111111111111111222222222222
import "@/assets/js/jquery-3.4.1.min.js"
import "@/assets/js/bootstrap.min.js"

import OmpLink from "@/components/common/OmpLink.vue"
import Control from "@/components/common/Control.vue"
import Footer from "@/components/common/Footer.vue"
import FreeTryButton from "@/components/common/FreeTryButton.vue"
import FreeTry from "@/components/common/FreeTry.vue"
import VideoJson from "@/components/Video.json"


  export default {
    components: {
        OmpLink, Control,Footer, FreeTryButton, FreeTry // Button, Modal
    },
    name: 'Video',
    data() {
      return {
          videoJson: null,
          activeName: 'first',
          popVideoId:'',
          popVideoTitle:'',
          freeTryVisible: false,
          searchText: null
      }
    },
    created(){
        this.videoJson = VideoJson;
        this.$http.post('/backend/web/record', {
            pageName: 'Video',
            contentName : '',
            extend2: 'CN',
            // extend3: window.localStorage.getItem('source')
        })
        .then(function (response) {
            if(response.status == 200){
                console.log("success");
            }
        })
        .catch(function (error) {
            console.log(error);
        });
        //获取top5
        var that = this
        that.videoJson.popular.videoList = [];
        this.$http.get('/backend/web/videoTop5?extend2=CN')
        .then(function (response) {
            if(response.status=='200'){
                if(response.data !== null && response.data.length >0){
                     response.data.forEach(v=>{
                        that.videoJson.popular.videoList.push(JSON.parse(v))
                        
                    })
                }
            }
        })
        .catch(function (error) {
            console.log(error);
        });
    },
    mounted() {
        this.VideoTopAnimate() // 顶部动画
        $('#myModal').on('hide.bs.modal',//模态框关闭触发事件
            function() {
                document.getElementById('popVideo').currentTime=0
                document.getElementById('popVideo').pause();
            })
    },
    methods: {
        search(){// 搜索
            let searchArr = [];
            this.videoJson.datasource.videoList.forEach(dv=>{
                if(dv.title.indexOf(this.searchText) != -1){
                    searchArr.push(dv);
                }
            });
            this.videoJson.worksheet.videoList.forEach(dv=>{
                if(dv.title.indexOf(this.searchText) != -1){
                    searchArr.push(dv);
                }
            });
            this.videoJson.chartDesign.videoList.forEach(dv=>{
                if(dv.title.indexOf(this.searchText) != -1){
                    searchArr.push(dv);
                }
            });
            this.videoJson.chartType.videoList.forEach(dv=>{
                if(dv.title.indexOf(this.searchText) != -1){
                    searchArr.push(dv);
                }
            });
            this.videoJson.dashboard.videoList.forEach(dv=>{
                if(dv.title.indexOf(this.searchText) != -1){
                    searchArr.push(dv);
                }
            });
            this.videoJson.mobile.videoList.forEach(dv=>{
                if(dv.title.indexOf(this.searchText) != -1){
                    searchArr.push(dv);
                }
            });
            this.videoJson.search.videoList = searchArr;
            this.activeName = "ninth";
        },
        handleClick(tab, event) {
            // console.log(tab, event);
        },
        VideoTopAnimate() {
            var videoAnimate_show1=1;
            $(".videoBody").children(".animateContent").each(function() {
                if($(this).hasClass("videoAnimate1") &&  parseInt(videoAnimate_show1)){
                    videoAnimate_show1 = 0;
                    $(this).find(".bannerPart").delay(800).addClass('animated fadeInUp');
                }
            });
        },
        // @click 视频播放
        toPlaying(videoId,videoTitle){
            this.getVideoClicks(videoId,videoTitle)
            document.getElementById('popVideo').currentTime=0
            this.popVideoId = videoId
            this.popVideoTitle = videoTitle
            $("#myModal").modal({});
        },
        // 点击量
        getVideoClicks(videoId,videoTitle) {
            this.$http.post('/backend/web/record', {
                pageName: 'Video',
                contentName : JSON.stringify({id:videoId ,title: videoTitle}),
                extend1: 'video', //类别-视频
                extend2: 'CN',
                // extend3: window.localStorage.getItem('source')
            })
            .then(function (response) {
                if(response.status == 200){
                    console.log("success");
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        getVisible(visible) {
            this.freeTryVisible = visible
        }
    }
  }
</script>
<style scoped>
body{
	background: #F5F8FA;
}
.headerBg{
	background: #F5F8FA url(../assets/img/header.png) no-repeat center center;
	height: 1060px;
}
.instruTitle{
	display:inline-block;
	width: 245px;
	height: 79px;
	background: url(../assets/img/title.png) no-repeat center;
	text-align:center;
	color: #fff;
}
.instruTitle div{
	line-height: 65px;
	font-size: 30px;
}
.proMakeTitle{
	background: url(../assets/img/title2.png) no-repeat center;
	text-align:center;
	color: #001926;
}
.proMakeTitle div{
	color:#00aaff;
	background:#fff;
	line-height: 45px;
	margin: 8px;
}
.instruTitle p{
	font-size: 14px;
}
.height140{
    height: 176px;
    background: #E6F7FF;
}
.des{
	padding: 2px 0;
	color: #001926;
	background:#E6F7FF;
	text-align: left;
}
.kailong{
    margin: 2px 5px;
	display: inline-block;
    width:0;
    height:0;
    border-top:8px solid transparent;
    border-bottom:8px solid transparent;
    border-left:12px solid #005D8C;
    cursor: pointer;
}
.kailong:hover{
    opacity: 0.6;
}
.imgWidth{
    width: 100%;
    height: 176px;
}
.positionR{
	position: relative;
}
.positionA{
	position: absolute;
	width: 100%;
    bottom: -20px;
}
.dataAccess{
    padding:0 10px 0 0;
    margin: 30px 0;
}
.videoBox{
	/* height: 168px;
    margin: 0 158px; */
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    overflow: hidden;
    position:relative;
    -webkit-transition: max-height .3s;
    transition: max-height .3s;
    padding-left: 30px;
}
.perVideo{
    width: 23%;
    margin-right: 2%;
}
video{
    object-fit: contain;
    width: 100%;
    height: 87%;
}
.modal-dialog{
    width: 100%;
    height: 100%;
}
#myModal::-webkit-scrollbar{
    display:none;
}
.modal-header{
    background: #FFFFFF!important;
}
.search{
    margin-bottom: 50px;
}
#searchText{
    width: 58%;
    height: 35px;
    background-color: #fff;
    padding-left: 10px;
    font-size: 14px;
    color: rgba(10,18,32,.87);
    border: 0;
    box-shadow: 0 -1px 0 0 rgb(81 130 228 / 60%) inset;
}
.modal {
    top:50%;
    transform: translateY(-50%);
    overflow-y:hidden;
}
</style>
<style>
    .el-tabs__header{
        margin:0 30px 15px!important;
    }
    .el-tabs__content{
        min-height: 540px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Video.vue